import { DrawerContent } from '@chakra-ui/react';

export const UiDrawerContent = DrawerContent;
